import { useNavigate } from 'react-router-dom';
import { openPopup } from '../apps/Utils';

function Header() {
    const home = "/tools/analog-inspection-tool/";
    const manual = "/tools/analog-inspection-tool/#/manual";
     const releasenote = "/tools/analog-inspection-tool/#/releasenote";
    const navigate = useNavigate();

    return (
        <header>
            <div>
                <h2>
                    <a href={home} onClick={(e) => { navigate(home); }}>アナログ規制点検ツールβ版</a>
                </h2>
            </div>
            <nav>
                <ul>
                    <li>
                        <a href={manual} onClick={(e) => { e.preventDefault(); openPopup(manual); }}>マニュアル</a>
                    </li>
                    <li>
                        <a href={releasenote} onClick={(e) => { e.preventDefault(); openPopup(releasenote); }}>リリースノート</a>
                    </li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;
